module.exports = __webpack_public_path__ + "img/logo-sc-full.8de1772d.png";